import Form from "../../../Form/Form";
import Input from "../../../Form/Input/Input";
import DefaultButton from "../../../../components/simple/DefaultButton";

const Auth = ({ user, setLoading, setError, setSuccess, brand }) => {
  const fields = [
    {
      id: "current_password",
      label: "Current password *",
      fields: [
        {
          id: "current_password",
          name: "current_password",
          type: "password",
          placeholder: "Enter your existing password.",
          helpText: "Enter your existing password.",
        },
      ],
    },
    {
      id: "new_password",
      label: "New password *",
      fields: [
        {
          id: "new_password",
          name: "new_password",
          type: "password",
          placeholder: "Choose a strong new password.",
          helpText: "Choose a strong new password. It must be more than 8 characters.",
        },
      ],
    },
    {
      id: "confirm_new_password",
      label: "Confirm new password *",
      fields: [
        {
          name: "confirm_new_password",
          type: "password",
          placeholder: "Re-enter your new password.",
          helpText: "Re-enter your new password.",
        },
      ],
    },
  ];

  const handleError = (err) => {
    setError(err || true);
    setLoading(false);
    setSuccess(false);
  };

  return (
    <div className="profile-fields-container">
      <Form
        action={`update_password`}
        method="POST"
        onError={handleError}
        onBefore={() => setLoading(true)}
        onSuccess={() => {
          setLoading(false);
          setSuccess(true);
          setError(false);
        }}
        auth
      >
        {({ register, formState: { errors }, control, getValues }) => (
          <>
            {fields.map((section, sectionIndex) => (
              <div key={sectionIndex} className="form-section">
                <label htmlFor={section.id}>{section.label}</label>
                <div className="field-group">
                  {section.fields.map((field, fieldIndex) => {
                    const isConfirm = field.name === "confirm_new_password";
                    return (
                      <Input
                        id={field.name}
                        label={field.label}
                        showLabel={false}
                        key={fieldIndex}
                        type={field.type || "text"}
                        placeHolder={field.placeholder}
                        register={register(field.name, {
                          required: "Field is required",
                          ...(isConfirm
                            ? {
                                validate: (value) => {
                                  const passwordValue = getValues("new_password");
                                  return (
                                    value === passwordValue ||
                                    "Passwords do not match"
                                  );
                                },
                              }
                            : {
                                minLength: {
                                  value: 8,
                                  message:
                                    "Password must be at least 8 characters long",
                                },
                                validate: {
                                  hasUppercase: (value) =>
                                    /[A-Z]/.test(value) ||
                                    "Password must include at least one uppercase letter",
                                  hasSpecialChar: (value) =>
                                    /[!@#$%^&*(),.?":{}|<>]/.test(value) ||
                                    "Password must include at least one special character",
                                },
                              }),
                        })}
                        error={errors[field.name]?.message}
                        control={control}
                        helpText={field.helpText}
                      />
                    );
                  })}
                </div>
              </div>
            ))}
            <div className="form-actions">
              <DefaultButton buttonSize="md" wideOnMobile type="submit">
                Save Changes
              </DefaultButton>
            </div>
          </>
        )}
      </Form>
    </div>
  );
};

export default Auth;
